import React, { createContext, useContext, useState } from 'react';
import locales from './locales';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('el'); // default Greek
  const value = {
    language,
    setLanguage,
    t: (key) => locales[language][key] || key,
  };
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
